import React from 'react';
import { Link } from '@mui/material';
import AppConfig from '../AppConfig';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function XeroLink(props: { shortCode: string; size?: string }) {
  const { shortCode, size } = props;
  return <ExternalLink link={AppConfig.xeroOrganisationPath + shortCode} label="Xero" size={size} />;
}

export function ExternalLink(props: { link: string; size?: string; label: string }) {
  const { link, size, label } = props;
  return (
    <Link style={{ whiteSpace: 'nowrap', fontSize: size || '12px' }} target="_blank" rel="noopener noreferrer" href={link}>
      <OpenInNewIcon sx={{ verticalAlign: 'middle', fontSize: size || '12px' }} />
      {label}
    </Link>
  );
}
